
















import { Vue, Component, Watch } from "vue-property-decorator";
import { api } from '../../api';
import { AxiosError } from 'axios';
import { CONFLICT, OK } from 'http-status-codes';
import { validEmail } from '../../utils/validation';
import { utf8_to_b64 } from "@/galaxy-cruise/utils/b64utf8";

@Component
export default class extends Vue {
  email = ''
  validateAlways = false
  locale = this.$root.$i18n.locale

  mounted() {
    (this.$refs.email as any).focus()
  }

  get ok() {
    return this.emailErrors.length  === 0
  }

  async submit() {
    if (!this.ok) {
      (this.$refs.dialog as any).shake(() => this.validateAlways = true)
      return
    }

    const locale = this.$root.$i18n.locale
    const { email } = this

    const axios = api.passErrors(CONFLICT)
    try {
      await axios.post('../api/v1/account_request', {
        locale, email,
      })
      const message = this.$t('mail_sent') as string
      this.$router.push(`/message?message=${encodeURIComponent(utf8_to_b64(message))}`)
    } catch (e) {
      const error: AxiosError = e
      switch (error.response!.status) {
        case CONFLICT:
          alert(this.$t('conflict'))
          break
      }
    }
  }

  get emailErrors() {
    return [!validEmail(this.email) && this.$t('invalid_format')].filter((e) => e)
  }

  back() {
    this.$router.back()
  }

  @Watch('locale')
  onLocaleChange() {
    this.$root.$i18n.locale = this.locale
  }

}
